import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';

import { Button } from '../button';

import { StepPaginationProps } from './types';

export const StepPagination = ({
  hasSteps,
  className,
  backTitle,
  nextTitle,
  handleBack,
  handleExit,
  handleNext,
  isLastStep,
  isFirstStep,
  handleFinish,
  isNextDisabled,
  isFinishDisabled,
  forwardButtonClassName,
}: StepPaginationProps) => {
  const { t } = useTranslation(['common']);

  const onBack = isFirstStep ? handleExit : handleBack;
  const showBack = isFirstStep ? !!handleExit : !!handleBack && hasSteps;

  return (
    <div className={twMerge('flex', className)}>
      {showBack && (
        <Button onClick={onBack} variant="outlined" className="min-w-[120px]">
          {backTitle || t('back')}
        </Button>
      )}
      {hasSteps && !isLastStep && (
        <Button
          onClick={handleNext}
          disabled={isNextDisabled}
          className={twMerge('ml-auto min-w-[120px]', forwardButtonClassName)}
        >
          {nextTitle || t('next')}
        </Button>
      )}
      {isLastStep && (
        <Button
          onClick={handleFinish}
          disabled={isFinishDisabled}
          className={twMerge('ml-auto min-w-[120px]', forwardButtonClassName)}
        >
          {t('finish')}
        </Button>
      )}
    </div>
  );
};
